import { CommonModule } from '@angular/common';
import {
  Component
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';

import {
  MatDialog,
  MatDialogRef
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PatientService } from '../../../services/patient.service';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'app-create-requisition-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule
  ],
  templateUrl: './patient-selection-dialog-component.html',
  styleUrls: ['./patient-selection-dialog-component.scss']
})
export class PatientSelectionDialogComponent {

  searchString = '';

  searchPatientData: any[] = [];

  showLoading = false;

  hasSearched = false;


  constructor(
    private dialog: MatDialog,
    public dialogRef:
      MatDialogRef<PatientSelectionDialogComponent>,
    private patientService: PatientService,

  ) { }


  close(): void {
    this.dialogRef.close();
  }


  searchPatientFromDb(): void {

    if (!this.searchString?.trim()) {

      this.searchPatientData = [];

      return;
    }

    const searchValue =
      this.searchString.trim();

    const requests: any[] = [];

    // Mobile Search
    if (
      searchValue.length === 10 &&
      !isNaN(Number(searchValue))
    ) {

      requests.push(
        this.patientService
          .getPatientsByFullNumberSearch(
            searchValue
          )
      );
    }

    // Name / UHID Search
    if (searchValue.length >= 3) {

      requests.push(
        this.patientService
          .searchPatientPostall({
            searchStr: searchValue
          })
      );
    }

    if (!requests.length) {

      this.searchPatientData = [];

      return;
    }

    this.showLoading = true;
    this.hasSearched = true;

    forkJoin(requests)
      .subscribe({

        next: (responses: any[]) => {
          this.showLoading = false;


          let allPatients: any[] = [];

          responses.forEach(
            (response: any) => {

              if (
                Array.isArray(response)
              ) {

                allPatients.push(
                  ...response
                );
              }
            }
          );

          const uniqueMap =
            new Map();

          allPatients.forEach(
            (patient: any) => {

              const key =
                patient._id ||
                patient.userId ||
                patient.contactNo;

              if (
                !uniqueMap.has(key)
              ) {

                uniqueMap.set(
                  key,
                  patient
                );
              }
            }
          );

          this.searchPatientData =
            Array.from(
              uniqueMap.values()
            );

          console.log(
            'Patients',
            this.searchPatientData
          );
        },

        error: (err) => {

          console.error(err);

          this.showLoading = false;
          this.searchPatientData = [];

          this.searchPatientData = [];
        }
      });
  }

  selectPatientForRequisition(patient: any) {

    this.dialogRef.close(patient);

  }

  openPatientOnboard(): void {

    this.dialogRef.close({
      openOnboard: true
    });
  }
  onSearchKeyup(): void {

    const value = this.searchString?.trim();

    if (!value || value.length < 3) {

      this.searchPatientData = [];
      this.hasSearched = false;

      return;
    }
    this.hasSearched = true;
    this.searchPatientFromDb();
  }
}